export default (blob, saveMetaData = false) => {
    return new Promise(async (res) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result;
            if (result.includes(',') && !saveMetaData) {
                res(result.substring(reader.result.indexOf(',') + 1));
            } else {
                res(result);
            }
        };
        reader.onerror = () => {
            res(false)
        };
        try {
            reader.readAsDataURL(blob);
        } catch (errorInfo) {
            res(false);
        }
    });
}